import { render } from "./Error.vue?vue&type=template&id=af8c436e"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"
script.render = render

export default script